import React, { useState } from "react";

import AddVoteDate from "./AddVoteDate";

import { VoteDateContextProvider } from "contexts/VoteDate";

const Index = props => {
  const SwitchComponents = ({ active, children }) => {
    return children.filter(child => child.props.name === active);
  };
  // Local State
  const [pageProps, setPageProps] = useState({
    active: "AddVoteDate",
    props: null
  });

  return (
    <VoteDateContextProvider>
      <SwitchComponents active={pageProps.active}>
        <AddVoteDate
          name="AddVoteDate"
          pageProps={pageProps}
          setPageProps={setPageProps}
        />
        <> </>
      </SwitchComponents>
    </VoteDateContextProvider>
  );
};

export default Index;
